import React from 'react'

export default function NewsLetterIcon() {
   return (
      <svg
         width="401"
         height="404"
         viewBox="0 0 401 404"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M372.172 151.963C366 114.94 339.101 96.1343 306.56 84.7403C283.991 76.8383 262.936 68.4693 242.24 57.0543C219.706 44.6253 200.396 27.3023 177.477 15.3393C158.062 5.20526 135.896 -1.82074 113.03 1.80326C94.8012 4.69226 77.3122 14.2413 62.4442 26.6563C27.7082 55.6623 6.60022 101.457 8.09822 144.562C9.66022 189.511 34.1692 228.402 65.6662 256.732C85.1042 274.216 107.812 288.412 133.062 296.666C155.245 303.917 246.227 309.259 295.236 283.985C341.092 260.338 380.403 201.339 372.172 151.963Z"
            fill="#F1ECDC"
         />
         <path
            opacity="0.6"
            d="M372.172 151.963C366 114.94 339.101 96.1343 306.56 84.7403C283.991 76.8383 262.936 68.4693 242.24 57.0543C219.706 44.6253 200.396 27.3023 177.477 15.3393C158.062 5.20526 135.896 -1.82074 113.03 1.80326C94.8012 4.69226 77.3122 14.2413 62.4442 26.6563C27.7082 55.6623 6.60022 101.457 8.09822 144.562C9.66022 189.511 34.1692 228.402 65.6662 256.732C85.1042 274.216 107.812 288.412 133.062 296.666C155.245 303.917 246.227 309.259 295.236 283.985C341.092 260.338 380.403 201.339 372.172 151.963Z"
            fill="#F1ECDC"
         />
         <path
            d="M67.8438 352.543L270.415 275.064"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M75.4067 122.291C63.6347 127.815 49.4827 123.139 43.3797 111.51C37.1037 99.552 41.7117 84.768 53.6697 78.492C57.2297 76.624 61.0407 75.72 64.8017 75.689C53.5777 82.577 49.4677 97.085 55.6777 108.917C59.7507 116.676 67.2957 121.44 75.4067 122.291Z"
            fill="#0F0C0B"
         />
         <path
            d="M83.8325 76.9726L82.8535 74.4616L80.2305 73.8446L82.3165 72.1376L82.0925 69.4526L84.3605 70.9086L86.8455 69.8656L86.1615 72.4726L87.9205 74.5136L85.2305 74.6686L83.8325 76.9726Z"
            fill="#0F0C0B"
         />
         <path
            d="M96.4541 102.27L95.0431 102.576L94.4951 103.912L93.7681 102.664L92.3281 102.556L93.2901 101.479L92.9481 100.076L94.2691 100.658L95.4981 99.8999L95.3531 101.336L96.4541 102.27Z"
            fill="#0F0C0B"
         />
         <path
            d="M49.9141 141.901L48.5031 142.207L47.9551 143.543L47.2281 142.295L45.7891 142.187L46.7501 141.11L46.4081 139.707L47.7301 140.289L48.9581 139.531L48.8131 140.967L49.9141 141.901Z"
            fill="#0F0C0B"
         />
         <path
            d="M15.5634 143.44L13.4904 140.558L9.94141 140.632L12.0414 137.77L10.8744 134.417L14.2454 135.53L17.0734 133.384L17.0564 136.934L19.9714 138.961L16.5904 140.042L15.5634 143.44Z"
            fill="#0F0C0B"
         />
         <path
            d="M294.707 343.979L296.753 373.67L342.402 402.436L391.519 370.339L399.752 342.959L337.714 323.144L294.707 343.979Z"
            fill="#F1ECDC"
         />
         <path
            d="M293.215 340.973L330.291 320.167L399.912 342.271L344.501 376.41L293.215 340.973Z"
            fill="#F1ECDC"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M294.406 340.451L296.751 373.671L342.477 402.591L344.501 376.412"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M342.477 402.59L391.329 370.152L399.912 342.271"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M285.027 340.059L344.822 371.324L396.542 337.194C396.542 337.194 335.958 318.446 334.786 318.055C333.614 317.664 285.027 340.059 285.027 340.059Z"
            fill="#F1ECDC"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
         />
         <path
            d="M342.176 364.098L381.651 337.912"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M338.074 361.364L377.549 335.177"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M332.016 359.603L371.491 333.417"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M327.324 357.062L366.799 330.876"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M325.132 376.128L318.574 371.904"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M372.926 369.902L384.819 362.9"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M365.812 381.017L373.371 376.794"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M80.5411 317.567C80.5711 317.577 80.6001 317.583 80.6301 317.593L72.0241 322.613V301.118L75.5691 298.643L86.8241 290.944C107.293 290.923 110.873 272.423 110.873 272.423C85.7131 270.981 85.4561 287.448 85.6191 290.465L72.0251 299.955V283.339C72.0431 283.345 72.0601 283.351 72.0781 283.356C72.0781 283.356 93.5921 276.831 71.7251 244.56C71.7251 244.56 48.5981 275.056 71.0721 283.022V317.596L61.8921 310.632C62.0511 307.208 61.5181 289.825 34.1641 290.938C34.1641 290.938 44.7001 317.334 61.3231 311.396L63.9231 313.369L70.9021 318.664C70.9521 318.702 71.0131 318.705 71.0711 318.721V330.789L56.3821 330.615L62.5541 367.824L80.3651 367.295L86.1841 330.968L72.0241 330.8V323.731L81.9181 317.96C98.5431 322.292 108.403 305.927 108.403 305.927C80.8931 300.99 80.5411 317.567 80.5411 317.567Z"
            fill="#0F0C0B"
         />
         <path
            d="M165.534 365.311C165.534 368.649 157.416 371.355 147.402 371.355C137.388 371.355 129.27 368.649 129.27 365.311C129.27 361.973 137.388 359.267 147.402 359.267C157.416 359.267 165.534 361.973 165.534 365.311Z"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M129.27 365.312C129.27 365.312 129.941 377.624 132.851 385.235C135.761 392.846 148.375 395.448 155.236 392.398C160.326 390.136 162.902 383.242 164.204 376.977"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M158.527 386.351C159.455 388.716 162.809 388.751 164.903 388.511C168.956 388.047 171.726 385.363 171.981 381.205C172.146 378.513 171.399 375.214 169.779 373.046C168.46 371.28 166.272 370.218 164.067 370.205C162.985 370.199 161.911 370.698 161.217 371.528C160.523 372.359 160.224 373.505 160.423 374.568C160.502 374.992 160.664 375.414 160.962 375.726C161.88 376.69 163.202 376.148 164.303 376.577C165.356 376.988 166.038 378.059 166.33 379.112C166.764 380.675 166.976 382.081 165.971 383.458C165.273 384.414 164.037 384.666 162.921 384.521C161.903 384.389 161.078 383.547 160.044 383.501C159.025 383.456 158.31 384.349 158.337 385.341C158.345 385.725 158.412 386.059 158.527 386.351Z"
            fill="#F1ECDC"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M147.484 371.084C156.607 371.084 164.003 369.197 164.003 366.87C164.003 364.542 156.607 362.656 147.484 362.656C138.361 362.656 130.965 364.542 130.965 366.87C130.965 369.197 138.361 371.084 147.484 371.084Z"
            fill="#0F0C0B"
         />
         <path
            d="M142.825 356.093C142.44 354.988 142.294 353.778 142.564 352.64C143.036 350.649 144.685 349.154 146.413 348.058C148.142 346.963 150.05 346.116 151.566 344.742C153.083 343.368 154.169 341.253 153.602 339.287C153.263 338.113 152.395 337.171 151.866 336.07C150.956 334.175 151.176 331.741 152.554 330.153C153.931 328.566 156.444 328.026 158.274 329.061C160.104 330.096 160.916 332.683 159.865 334.503C159.221 335.618 158.05 336.333 157.314 337.39C156.286 338.868 156.277 340.982 157.292 342.469C158.052 343.582 159.325 344.378 159.708 345.67C160.089 346.955 159.414 348.382 158.355 349.205C157.296 350.028 155.931 350.347 154.597 350.484C153.271 350.62 151.912 350.602 150.641 351.005C148.743 351.608 147.183 353.186 146.603 355.091C146.023 356.996 146.438 359.175 147.678 360.734C148.433 361.683 147.74 361.144 146.56 360.465C144.865 359.491 143.473 357.953 142.825 356.093Z"
            fill="#0F0C0B"
         />
         <path
            d="M142.829 356.081C142.444 354.976 142.298 353.766 142.568 352.628C143.04 350.637 144.689 349.142 146.417 348.047C148.146 346.952 150.054 346.105 151.57 344.731C153.086 343.357 154.173 341.243 153.606 339.276C153.267 338.102 152.399 337.16 151.87 336.059C150.96 334.164 151.18 331.73 152.558 330.142C153.935 328.554 156.448 328.015 158.278 329.05C160.108 330.085 160.92 332.672 159.869 334.492C159.225 335.607 158.054 336.322 157.318 337.379C156.29 338.857 156.281 340.971 157.296 342.458C158.056 343.571 159.329 344.367 159.712 345.659C160.093 346.945 159.418 348.371 158.359 349.194C157.3 350.017 155.935 350.336 154.601 350.473C153.275 350.609 151.916 350.591 150.645 350.994C148.747 351.597 147.187 353.175 146.607 355.08C146.027 356.985 146.442 359.165 147.682 360.723C148.437 361.672 147.744 361.133 146.564 360.454C144.869 359.48 143.477 357.941 142.829 356.081Z"
            fill="#F1ECDC"
         />
         <path
            d="M251.414 261.848V79.4917"
            stroke="#0F0C0B"
            strokeWidth="1.0496"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M110.816 241.847V60.6265"
            stroke="#0F0C0B"
            strokeWidth="1.0496"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M5.35547 162.08H316.756"
            stroke="#0F0C0B"
            strokeWidth="1.0206"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M148.574 125.07L144.348 127.935"
            stroke="#0F0C0B"
            strokeWidth="0.5248"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M67.154 178.953L1.5 223.527"
            stroke="#0F0C0B"
            strokeWidth="1.0496"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M60.0492 172.72L44.1562 183.501"
            stroke="#0F0C0B"
            strokeWidth="1.0496"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M351.261 93.798C356.412 75.3131 345.602 56.1529 327.117 51.0026C308.632 45.8522 289.472 56.662 284.322 75.1468C279.171 93.6317 289.981 112.792 308.466 117.942C326.951 123.093 346.111 112.283 351.261 93.798Z"
            fill="#0F0C0B"
         />
         <path
            d="M328.172 110.021C342.271 104.294 349.059 88.2223 343.332 74.1232C337.606 60.024 321.534 53.2366 307.435 58.963C293.336 64.6894 286.548 80.7612 292.275 94.8603C298.001 108.959 314.073 115.747 328.172 110.021Z"
            fill="#F1ECDC"
         />
         <path
            d="M320.124 84.4778C320.124 85.7598 319.085 86.7998 317.802 86.7998C316.52 86.7998 315.48 85.7598 315.48 84.4778C315.48 83.1958 316.519 82.1558 317.802 82.1558C319.085 82.1558 320.124 83.1958 320.124 84.4778Z"
            fill="#0F0C0B"
         />
         <path
            d="M318.145 85.1603V62.5073"
            stroke="#0F0C0B"
            strokeWidth="1.1365"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M317.795 84.1283L312.543 66.5503"
            stroke="#0F0C0B"
            strokeWidth="1.1365"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M130.932 328.677L99.5204 205.034C98.1554 199.66 100.806 194.056 105.849 191.751C133.704 179.022 180.843 165.372 217.744 165.928C223.679 166.018 228.568 170.615 229.037 176.532L237.14 278.733C237.54 283.774 234.603 288.485 229.901 290.346L130.932 328.677Z"
            fill="#0F0C0B"
         />
         <path
            opacity="0.5"
            d="M130.932 328.677L99.5204 205.034C98.1554 199.66 100.806 194.056 105.849 191.751C133.704 179.022 180.843 165.372 217.744 165.928C223.679 166.018 228.568 170.615 229.037 176.532L237.14 278.733C237.54 283.774 234.603 288.485 229.901 290.346L130.932 328.677Z"
            fill="#0F0C0B"
         />
         <path
            d="M210.689 367.632L267.008 343.759C269.172 342.842 269.503 339.912 267.598 338.535L245.41 322.501C244.588 321.907 243.522 321.766 242.574 322.125L185.004 343.932C182.797 344.768 182.361 347.7 184.229 349.142L207.667 367.242C208.53 367.909 209.685 368.058 210.689 367.632Z"
            fill="#0F0C0B"
         />
         <path
            d="M236.026 328.943C236.026 328.943 254.016 331.521 256.122 341.353C258.229 351.184 218.201 351.535 214.69 344.162C211.179 336.788 230.057 328.943 236.026 328.943Z"
            fill="#F1ECDC"
         />
         <path
            d="M250.056 337.946C250.056 337.946 247.159 324.157 238.932 321.724C230.705 319.291 211.587 322.072 211.587 322.072L171.78 298.685L146.227 316.293L157.564 320.892L157.476 321.03C157.476 321.03 159.332 321.738 162.341 322.83L168.988 325.527L169.284 325.291C179.656 328.878 194.4 333.57 203.034 334.518C203.034 334.518 208.342 340.033 213.788 341.076C213.788 341.076 217.264 341.887 219.234 341.308C221.204 340.729 223.405 340.265 226.186 341.424C228.967 342.583 238.337 346.957 240.604 345.754C242.871 344.552 239.395 340.612 233.022 337.021C233.022 337.021 245.768 340.845 248.433 340.845C251.098 340.845 252.141 340.381 252.025 339.802L250.056 337.946Z"
            fill="#F1ECDC"
         />
         <path
            d="M163.852 310.154L204.31 331.057C206.907 334.101 210.171 336.76 214.089 337.573C216.163 338.003 218.309 337.699 220.427 337.661C227.355 337.537 234.285 340.444 239.051 345.475C239.051 345.475 237.576 345.892 234.879 344.769C232.182 343.645 225.171 338.746 219.236 341.308C213.301 343.87 203.037 334.518 203.037 334.518C203.037 334.518 161.381 325.888 147.895 316.898L163.852 310.154Z"
            fill="#F1ECDC"
         />
         <path
            opacity="0.5"
            d="M163.852 310.154L204.31 331.057C206.907 334.101 210.171 336.76 214.089 337.573C216.163 338.003 218.309 337.699 220.427 337.661C227.355 337.537 234.285 340.444 239.051 345.475C239.051 345.475 237.576 345.892 234.879 344.769C232.182 343.645 225.171 338.746 219.236 341.308C213.301 343.87 203.037 334.518 203.037 334.518C203.037 334.518 161.381 325.888 147.895 316.898L163.852 310.154Z"
            fill="#F1ECDC"
         />
         <path
            d="M229.953 335.357C229.953 335.357 248.822 342.368 251.28 340.613C253.738 338.857 243.414 333.113 232.178 329.251"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M237.695 325.695C241.436 327.041 245.317 329.267 247.94 332.452"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M249.685 337.544C249.685 337.544 246.977 326.29 241.007 322.427C235.038 318.565 211.178 322.17 211.178 322.17L167.922 296.246"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M147.008 316.972C151.321 318.716 156.804 320.815 163.71 323.281C188.288 332.059 203.035 334.517 203.035 334.517C203.035 334.517 211.698 343.616 220.24 340.837C226.004 338.962 236.743 347.508 240.605 345.753C244.467 343.997 234.82 337.28 222.882 332.014"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M268.445 275.484L294.014 246.218C294.014 246.218 287.129 233.39 278.56 219.09C270.028 204.851 259.821 189.152 255.488 183.248C243.43 177.359 260.442 249.848 260.442 249.848L268.445 275.484Z"
            fill="#F1ECDC"
         />
         <path
            d="M294.548 247.548C283.63 223.83 255.48 182.886 255.48 182.886"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M165.177 266.146L187.304 307.483L257.945 280.012L260.677 247.187C264.69 219.395 255.478 182.819 255.478 182.819L209.441 172.931C209.441 172.931 143.426 195.538 142.462 199.824C141.498 204.109 165.177 266.146 165.177 266.146Z"
            fill="#F1ECDC"
         />
         <path
            d="M165.177 266.146L187.304 307.483L257.945 280.012L260.677 247.187C264.69 219.395 255.478 182.819 255.478 182.819L209.441 172.931C209.441 172.931 143.426 195.538 142.462 199.824C141.498 204.109 165.177 266.146 165.177 266.146Z"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
         />
         <path
            opacity="0.2"
            d="M151.373 211.921C153.069 215.523 161.416 234.212 164.388 238.917C168.351 204.986 166.998 201.256 170.05 199.477C174.782 196.72 179.514 193.962 184.246 191.205L176.824 186.673L176.483 185.134C176.483 185.134 147.329 196.206 142.594 199.962C142.594 199.962 146.109 200.744 151.373 211.921Z"
            fill="#0F0C0B"
         />
         <path
            opacity="0.2"
            d="M292.939 246.295C296.027 244.488 285.854 247.535 282.674 249.177C280.08 250.517 277.289 252.351 274.486 251.533C271.586 250.686 270.218 247.419 269.467 244.493C267.159 235.502 266.999 226.089 265.027 217.019C263.626 210.578 261.326 204.37 258.938 198.226C258.938 198.226 263.401 226.181 260.51 248.182L267.615 273.006C267.615 273.006 267.07 261.431 292.939 246.295Z"
            fill="#0F0C0B"
         />
         <path
            d="M130.339 298.731C130.339 298.731 151.681 303.617 171.994 288.703C171.994 288.703 171.465 256.851 168.378 248.777C164.414 238.409 146.45 197.905 142.593 199.962C139.869 201.415 134.24 245.326 131.62 274.355C130.53 286.434 129.961 295.936 130.339 298.731Z"
            fill="#F1ECDC"
         />
         <path
            d="M130.339 298.731C130.339 298.731 151.681 303.617 171.994 288.703C171.994 288.703 171.465 256.851 168.378 248.777C164.414 238.409 146.45 197.905 142.593 199.962C139.869 201.415 134.24 245.326 131.62 274.355C130.53 286.434 129.961 295.936 130.339 298.731Z"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
         />
         <path
            d="M172.383 240.585C175.308 249.093 175.911 258.386 174.109 267.2"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M149.414 274.206C155.874 273.457 162.605 275.409 167.663 279.496"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M157.457 269.384C163.341 272.135 168.365 276.692 171.676 282.28"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            opacity="0.2"
            d="M148.639 206.413C153.517 215.625 151.125 227.113 152.368 237.463C153.038 243.04 153.756 248.773 156.458 253.698C158.425 257.284 161.344 260.246 163.663 263.616C166.431 267.637 168.335 272.25 169.208 277.053C162.995 270.79 156.218 264.219 147.543 262.615C151.667 264.709 157.397 269.53 155.93 271.049C153.044 273.772 149.496 267.482 146.527 269.256C145.261 270.012 144.61 271.469 144.141 272.867C142.797 276.871 142.322 281.165 142.758 285.366L129.516 291.475C129.516 291.475 137.567 206.904 142.594 199.964C142.593 199.962 146.261 201.923 148.639 206.413Z"
            fill="#0F0C0B"
         />
         <path
            d="M257.109 216.939C258.936 225.345 260.3 233.852 261.192 242.408"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M147.514 317.723C147.514 317.723 173.737 306.898 176.546 302.685C179.355 298.472 172.917 283.794 169.757 281.336C166.597 278.878 126.681 286.482 127.735 294.557C128.788 302.633 131.832 301.767 130.63 308.548C129.83 313.055 135.192 322.944 147.514 317.723Z"
            fill="#F1ECDC"
         />
         <path
            d="M164.108 309.643C167.796 306.789 154.925 311.457 150.27 311.186C148.747 311.097 147.046 310.825 146.142 309.596C145.425 308.622 145.424 307.253 145.883 306.134C146.342 305.015 147.199 304.107 148.107 303.309C150.622 301.101 153.651 299.548 156.775 298.345C158.155 297.814 160.423 297.342 159.755 295.484C158.434 293.49 154.781 295.525 152.446 296.538C150.111 297.551 147.204 298.377 145.194 296.817C143.546 295.538 143.256 293.034 144.053 291.105C144.849 289.176 146.497 287.733 148.213 286.546C148.818 286.128 149.467 285.7 149.788 285.039C150.109 284.377 149.925 283.41 149.23 283.169C149.23 283.169 130.252 288.361 128.856 293.248C127.46 298.135 131.125 304.592 131.125 304.592C131.125 304.592 128.885 312.66 134.644 317.023C140.404 321.388 155.554 316.264 164.108 309.643Z"
            fill="#F1ECDC"
         />
         <path
            opacity="0.7"
            d="M164.108 309.643C167.796 306.789 154.925 311.457 150.27 311.186C148.747 311.097 147.046 310.825 146.142 309.596C145.425 308.622 145.424 307.253 145.883 306.134C146.342 305.015 147.199 304.107 148.107 303.309C150.622 301.101 153.651 299.548 156.775 298.345C158.155 297.814 160.423 297.342 159.755 295.484C158.434 293.49 154.781 295.525 152.446 296.538C150.111 297.551 147.204 298.377 145.194 296.817C143.546 295.538 143.256 293.034 144.053 291.105C144.849 289.176 146.497 287.733 148.213 286.546C148.818 286.128 149.467 285.7 149.788 285.039C150.109 284.377 149.925 283.41 149.23 283.169C149.23 283.169 130.252 288.361 128.856 293.248C127.46 298.135 131.125 304.592 131.125 304.592C131.125 304.592 129.206 312.66 134.965 317.023C140.725 321.388 155.554 316.264 164.108 309.643Z"
            fill="#F1ECDC"
         />
         <path
            d="M147.901 317.723C147.901 317.723 174.124 306.898 176.933 302.685C179.742 298.472 173.304 283.794 170.144 281.336C166.984 278.878 127.068 286.482 128.122 294.557C129.175 302.633 132.219 301.767 131.017 308.548C130.217 313.055 135.578 322.944 147.901 317.723Z"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
         />
         <path
            d="M271.647 281.637C271.397 281.435 271.156 281.221 270.925 280.995C264.271 274.498 268.484 266.313 273.888 260.636C278.88 255.393 287.81 247.41 295.33 246.51C298.715 246.105 300.226 247.983 302.196 250.358C303.329 251.723 304.727 252.855 305.818 254.254C309.186 258.574 309.077 265.34 305.374 269.44C302.26 272.887 297.97 274.165 293.844 275.912C288.864 278.021 284.188 281.511 279.112 283.239C276.487 284.133 273.757 283.34 271.647 281.637Z"
            fill="#F1ECDC"
         />
         <path
            d="M293.043 275.38C297.016 272.29 301.067 269.191 303.771 264.947C304.795 263.34 305.701 261.555 305.703 259.649C305.705 257.743 304.549 255.722 302.691 255.297C301.183 254.952 299.661 255.69 298.289 256.405C296.894 257.132 295.499 257.86 294.104 258.587C293.596 258.852 293.029 259.125 292.474 258.985C291.678 258.785 291.318 257.849 291.269 257.029C291.133 254.737 292.417 252.629 293.653 250.694C294.416 249.501 295.178 248.307 295.94 247.114C295.652 246.834 295.159 246.798 294.834 247.034C294.834 247.034 283.031 249.275 275.058 259.674C267.085 270.073 266.392 273.713 268.992 278.566C271.591 283.419 276.239 288.447 293.043 275.38Z"
            fill="#F1ECDC"
         />
         <path
            opacity="0.7"
            d="M293.043 275.38C297.033 272.312 301.067 269.191 303.771 264.947C304.795 263.34 305.701 261.555 305.703 259.649C305.705 257.743 304.549 255.722 302.691 255.297C301.183 254.952 299.661 255.69 298.289 256.405C296.894 257.132 295.499 257.86 294.104 258.587C293.596 258.852 293.029 259.125 292.474 258.985C291.678 258.785 291.318 257.849 291.269 257.029C291.133 254.737 292.417 252.629 293.653 250.694C294.416 249.501 295.178 248.307 295.94 247.114C295.652 246.834 295.159 246.798 294.834 247.034C294.834 247.034 283.031 249.275 275.058 259.674C267.085 270.073 266.392 273.713 268.992 278.566C271.591 283.419 276.44 288.145 293.043 275.38Z"
            fill="#F1ECDC"
         />
         <path
            d="M271.647 281.637C271.397 281.435 271.156 281.221 270.925 280.995C264.271 274.498 268.484 266.313 273.888 260.636C278.88 255.393 287.81 247.41 295.33 246.51C298.715 246.105 300.226 247.983 302.196 250.358C303.329 251.723 304.727 252.855 305.818 254.254C309.186 258.574 309.077 265.34 305.374 269.44C302.26 272.887 297.97 274.165 293.844 275.912C288.864 278.021 284.188 281.511 279.112 283.239C276.487 284.133 273.757 283.34 271.647 281.637Z"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
         />
         <path
            d="M171.821 95.1774C171.166 90.3354 172.902 85.3404 175.976 81.5424C179.049 77.7444 183.363 75.0774 187.959 73.4194"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M217.339 161.08C216.707 168.574 216.463 186.22 216.911 193.727L188.677 180.554C189.672 173.762 190.05 161.422 188.355 154.769L217.339 161.08Z"
            fill="#F1ECDC"
         />
         <path
            d="M217.339 161.08C216.707 168.574 216.463 186.22 216.911 193.727L188.677 180.554C189.672 173.762 190.05 161.422 188.355 154.769L217.339 161.08Z"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
         />
         <path
            d="M189.668 159.082C189.668 159.082 198.024 174.604 206.813 174.888C215.389 175.165 217.313 162.377 217.313 162.377C217.313 162.377 213.749 169.139 209.882 168.996C206.014 168.852 189.668 159.082 189.668 159.082Z"
            fill="#0F0C0B"
         />
         <path
            d="M226.25 95.2082C226.25 95.2082 189.725 87.3932 179.397 96.9422C169.069 106.491 171.611 117.127 171.611 117.127C171.611 117.127 171.965 118.297 172.547 120.197C172.287 120.199 172.025 120.222 171.764 120.283C169.018 120.926 166.23 124.281 167.152 129.074C168.074 133.867 173.931 144.377 178.245 143.263C178.796 143.121 179.25 142.917 179.654 142.686C181.093 147.025 182.355 150.61 183.048 152.071C185.799 157.873 206.726 169.941 211.639 168.272C216.6 166.587 229.429 141.587 230.064 135.552C230.698 129.517 226.25 95.2082 226.25 95.2082Z"
            fill="#F1ECDC"
         />
         <path
            d="M226.693 100.559C222.267 105.246 214.959 105.831 208.617 104.673C202.275 103.515 196.198 100.944 189.771 100.435C188.007 100.295 186.16 100.329 184.57 101.106C181.932 102.394 180.586 105.503 180.549 108.439C180.513 111.374 181.547 114.204 182.563 116.958C183.578 119.713 184.602 122.548 184.543 125.483C184.516 126.834 184.258 128.172 184.207 129.523C184.003 134.926 185.266 141.028 187.088 146.096C191.385 158.047 202.421 162.872 213.487 167.11C213.487 167.11 209.456 170.414 201.589 166.212C198.825 164.736 188.357 157.688 188.357 157.688C188.357 157.688 183.512 154.997 181.539 148.717C179.565 142.437 179.565 142.437 179.565 142.437C179.565 142.437 176.515 144.59 173.644 141.36C170.773 138.13 166.467 132.209 166.826 127.544C167.185 122.879 168.018 120.872 172.383 120.574C176.748 120.276 178.309 123.955 178.309 123.955L174.9 103.68C174.9 103.68 185.127 93.9908 192.484 95.4258C199.84 96.8608 216.527 99.5527 220.654 98.4757C224.781 97.3987 226.396 96.6818 226.396 96.6818L226.693 100.559Z"
            fill="#F1ECDC"
         />
         <path
            opacity="0.5"
            d="M226.693 100.56C222.267 105.247 214.959 105.832 208.617 104.674C202.275 103.516 196.198 100.945 189.771 100.436C188.007 100.296 186.16 100.33 184.57 101.107C181.932 102.395 180.586 105.504 180.549 108.44C180.513 111.375 181.547 114.205 182.563 116.959C183.578 119.714 184.602 122.549 184.543 125.484C184.516 126.835 184.258 128.173 184.207 129.524C184.003 134.927 185.266 141.029 187.088 146.097C191.385 158.048 202.408 162.853 213.475 167.091C213.475 167.091 209.367 170.326 203.109 166.839C200.372 165.314 188.357 157.689 188.357 157.689C188.357 157.689 183.512 154.998 181.539 148.718C179.565 142.438 179.565 142.438 179.565 142.438C179.565 142.438 176.515 144.591 173.644 141.361C170.773 138.131 166.467 132.21 166.826 127.545C167.185 122.88 167.589 121.374 171.954 121.077C176.319 120.779 178.31 123.957 178.31 123.957L174.901 103.682C174.901 103.682 185.128 93.9927 192.485 95.4277C199.841 96.8627 216.528 99.5547 220.655 98.4777C224.782 97.4007 226.397 96.6837 226.397 96.6837L226.693 100.56Z"
            fill="#F1ECDC"
         />
         <path
            d="M206.339 128C206.34 129.754 205.7 131.177 204.907 131.178C204.115 131.179 203.471 129.757 203.469 128.002C203.467 126.247 204.108 124.824 204.901 124.824C205.693 124.824 206.337 126.246 206.339 128Z"
            fill="#0F0C0B"
         />
         <path
            d="M222.202 127.178C222.203 128.933 221.562 130.355 220.77 130.356C219.977 130.357 219.334 128.935 219.332 127.181C219.331 125.426 219.971 124.003 220.764 124.003C221.557 124.001 222.2 125.423 222.202 127.178Z"
            fill="#0F0C0B"
         />
         <path
            d="M217.394 149.703C214.935 149.4 212.418 149.566 210.02 150.191"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M200.164 133.504C201.436 135.561 204.368 135.56 206.109 134.139C206.927 133.471 207.386 132.604 207.962 131.746"
            stroke="#0F0C0B"
            strokeWidth="0.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M217.926 131.865C218.774 133.203 220.275 134.105 221.855 134.225C222.816 134.298 223.791 134.082 224.643 133.633"
            stroke="#0F0C0B"
            strokeWidth="0.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M199.211 121.886C202.508 121.216 205.63 119.706 208.202 117.539"
            stroke="#0F0C0B"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M218.949 114.216C220.265 115.806 221.927 117.108 223.785 118.006"
            stroke="#0F0C0B"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M213.445 125.566C213.737 127.633 214.029 129.701 214.321 131.768C214.447 132.66 214.578 133.568 214.968 134.38C215.671 135.843 217.241 136.847 218.864 136.871C219.347 136.878 219.867 136.815 220.277 137.068C220.681 137.318 220.866 137.826 220.847 138.301C220.815 139.109 220.295 139.809 219.749 140.405C218.736 141.511 217.552 142.462 216.254 143.213"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M171.789 126.582C175.072 129.256 176.78 133.736 176.113 137.917"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M171.199 131.809C171.379 131.341 171.846 131.028 172.335 130.916C172.824 130.804 173.335 130.863 173.828 130.953C174.178 131.017 174.533 131.098 174.84 131.278C175.147 131.458 175.606 132.003 175.66 132.355"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M181.132 135.829C181.132 135.829 183.305 142.071 177.911 143.462C173.594 144.577 167.734 134.066 166.81 129.273C166.248 126.319 167.086 123.908 168.458 122.345C169.316 121.373 170.373 120.735 171.431 120.487C174.623 119.734 177.796 123.603 179.807 126.776C181.112 128.853 181.826 129.704 181.826 129.704"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M179.312 142.884C180.752 147.226 182.014 150.81 182.708 152.273C185.459 158.075 206.386 170.143 211.299 168.474C216.26 166.789 229.089 141.789 229.724 135.753C230.359 129.717 225.912 95.4094 225.912 95.4094C225.912 95.4094 189.387 87.5944 179.059 97.1434C168.73 106.692 171.273 117.328 171.273 117.328"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
         />
         <path
            d="M234.708 78.7261C234.708 78.7261 240.347 90.4751 233.142 98.4631C225.936 106.452 209.488 99.8731 209.488 99.8731"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M227.861 73.3859C225.574 74.3099 229.481 78.3119 224.621 79.5419C219.761 80.7809 181.178 62.8569 171.468 94.0639C171.468 94.0639 154.173 106.337 168.457 122.346C169.315 121.374 170.372 120.736 171.43 120.488C174.529 119.757 177.608 123.381 179.624 126.497C180.524 129.102 181.936 131.428 184.091 130.644C188.01 129.217 186.686 124.315 185.066 120.721C184.554 119.585 184.012 118.58 183.596 117.856C181.143 113.583 177.495 108.875 179.159 103.672C182.477 97.4429 192.571 96.4629 202.171 98.9129C218.046 102.963 236.628 97.1599 236.342 85.7249C236.056 74.2909 230.138 72.4519 227.861 73.3859Z"
            fill="#0F0C0B"
         />
         <path
            opacity="0.5"
            d="M235.139 78.5206C235.115 78.4706 235.08 78.4316 235.044 78.3936C233.105 73.4996 229.519 72.7056 227.861 73.3856C225.574 74.3096 229.481 78.3115 224.621 79.5415C219.877 80.7505 183 63.7076 172.215 91.9275C172.478 88.4075 173.905 84.8586 176.347 81.8416C179.133 78.3996 183.204 75.6416 188.121 73.8676C188.369 73.7786 188.497 73.5056 188.407 73.2576C188.318 73.0106 188.046 72.8816 187.797 72.9716C182.717 74.8046 178.501 77.6646 175.606 81.2426C172.678 84.8606 171.124 89.2176 171.21 93.4356C168.177 94.0986 165.309 95.5156 162.971 97.5626C160.064 100.107 157.992 103.583 157.137 107.349C157.079 107.606 157.24 107.861 157.496 107.919C157.532 107.927 157.567 107.931 157.602 107.931C157.819 107.931 158.016 107.781 158.066 107.56C158.877 103.988 160.841 100.692 163.598 98.2796C165.697 96.4426 168.243 95.1336 170.948 94.4646C168.187 96.6806 155.667 108.012 168.457 122.346C169.315 121.374 170.372 120.736 171.43 120.488C174.529 119.757 177.608 123.381 179.624 126.497C180.524 129.102 181.936 131.428 184.091 130.644C188.01 129.217 186.686 124.315 185.066 120.721C184.554 119.585 184.012 118.58 183.596 117.856C181.143 113.583 177.495 108.875 179.159 103.672C182.477 97.4426 192.571 96.4625 202.171 98.9125C204.43 99.4886 206.743 99.8586 209.049 100.049C209.096 100.166 209.186 100.265 209.313 100.316C209.732 100.483 215.946 102.922 222.388 102.922C226.472 102.922 230.648 101.942 233.497 98.7826C240.832 90.6506 235.197 78.6406 235.139 78.5206ZM232.79 98.1446C227.439 104.078 216.58 101.622 211.899 100.19C224.109 100.386 235.37 95.4005 236.276 87.0715C236.5 90.6295 235.846 94.7556 232.79 98.1446Z"
            fill="#0F0C0B"
         />
         <path
            d="M177.043 100.432C179.592 95.6337 185.319 93.2677 190.748 93.0587C196.177 92.8497 201.495 94.3997 206.8 95.5737C212.105 96.7477 217.731 97.5397 222.899 95.8627C228.067 94.1857 232.577 89.3737 232.238 83.9507"
            stroke="#F1ECDC"
            strokeWidth="0.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M176 96.9907C176.906 93.4067 179.746 90.6277 182.796 88.5387C187.447 85.3537 192.877 83.3177 198.475 82.6597"
            stroke="#F1ECDC"
            strokeWidth="0.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M205.903 191.165C206.312 190.756 217.495 188.71 217.495 188.71C217.495 188.71 215.586 201.938 216.541 206.711L211.904 207.529C211.904 207.529 207.404 199.21 203.858 196.619C200.311 194.029 205.903 191.165 205.903 191.165Z"
            fill="#0F0C0B"
         />
         <path
            d="M212.543 205.332L212.618 261.485L225.276 271.053L230.66 257.51L215.092 204.109L212.543 205.332Z"
            fill="#0F0C0B"
         />
         <path
            d="M212.138 181.971L218.322 173.718C218.703 173.21 219.445 173.157 219.894 173.606L227.801 181.513C228.131 181.843 228.202 182.353 227.973 182.761L218.478 199.698C218.022 200.511 216.811 200.364 216.563 199.466L211.967 182.876C211.881 182.564 211.944 182.23 212.138 181.971Z"
            fill="#F1ECDC"
         />
         <path
            d="M212.138 181.971L218.322 173.718C218.703 173.21 219.445 173.157 219.894 173.606L227.801 181.513C228.131 181.843 228.202 182.353 227.973 182.761L218.478 199.698C218.022 200.511 216.811 200.364 216.563 199.466L211.967 182.876C211.881 182.564 211.944 182.23 212.138 181.971Z"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M186.861 172.45L210.899 182.011C211.42 182.218 211.684 182.799 211.497 183.328L205.339 200.756C205.125 201.36 204.422 201.631 203.858 201.326L176.824 186.674C176.266 186.372 176.105 185.645 176.483 185.135L185.637 172.798C185.919 172.418 186.421 172.275 186.861 172.45Z"
            fill="#F1ECDC"
         />
         <path
            d="M186.861 172.45L210.899 182.011C211.42 182.218 211.684 182.799 211.497 183.328L205.339 200.756C205.125 201.36 204.422 201.631 203.858 201.326L176.824 186.674C176.266 186.372 176.105 185.645 176.483 185.135L185.637 172.798C185.919 172.418 186.421 172.275 186.861 172.45Z"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M267.444 273.257L260.348 249.65"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
         />
         <path
            d="M282.039 281.357L233.082 301.941C230.887 302.864 230.603 305.86 232.586 307.178L270.417 332.327L295.026 307.76L282.039 281.357Z"
            fill="#F1ECDC"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
         />
         <path
            d="M261.633 303.027L255.734 305.337L258.898 307.562L264.797 305.252L261.633 303.027ZM261.633 303.027L255.734 305.337L258.898 307.562L264.797 305.252L261.633 303.027ZM261.633 303.027L255.734 305.337L258.898 307.562L264.797 305.252L261.633 303.027ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM252.427 311.015L255.923 313.399L262.212 310.947L258.782 308.529L252.427 311.015ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM270.881 308.474L274.813 311.238L275.103 311.125L276.203 306.399L270.881 308.474ZM270.039 307.883L269.079 308.259L269.922 308.85L270.882 308.474L270.039 307.883ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM275.681 305.674L276.277 306.087L276.443 305.382L275.681 305.674ZM270.039 307.883L269.079 308.259L269.922 308.85L270.882 308.474L270.039 307.883ZM272.252 303.264L266.61 305.473L270.039 307.883L275.681 305.673L272.252 303.264ZM270.039 307.883L269.079 308.259L269.922 308.85L270.882 308.474L270.039 307.883ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM270.039 307.883L269.079 308.259L269.922 308.85L270.882 308.474L270.039 307.883ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM270.881 308.474L274.813 311.238L273.845 311.615L274.697 312.205L268.789 314.516L267.946 313.925L266.986 314.301L267.838 314.891L261.649 317.314L264.691 319.389L270.822 316.99L271.675 317.589L265.552 319.978L269.586 322.73L272.015 324.394L272.681 321.523L273.324 318.75L273.537 317.858L273.794 316.761L274.026 315.745L274.831 312.302L274.864 312.142L275.043 311.401L275.105 311.125L276.205 306.399L270.881 308.474ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM270.039 307.883L269.079 308.259L269.922 308.85L270.882 308.474L270.039 307.883ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM270.039 307.883L269.079 308.259L269.922 308.85L270.882 308.474L270.039 307.883ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM270.039 307.883L269.079 308.259L269.922 308.85L270.882 308.474L270.039 307.883ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM270.039 307.883L269.079 308.259L269.922 308.85L270.882 308.474L270.039 307.883ZM273.211 302.888L276.479 305.187L277.398 301.254L273.211 302.888ZM268.235 300.441L262.593 302.65L261.749 302.05L267.392 299.849L268.235 300.441L269.195 300.065L268.352 299.474L274.326 297.138L271.303 295.009L265.348 297.36L264.388 297.736L258.764 299.952L257.796 300.329L251.916 302.654L250.956 303.03L244.48 305.583L247.485 307.637L253.922 305.115L254.766 305.715L248.346 308.227L251.568 310.428L257.939 307.94L258.782 308.531L259.742 308.155L258.899 307.564L264.798 305.254L265.642 305.854L266.61 305.477L265.757 304.878L271.399 302.669L268.235 300.441ZM255.734 305.336L254.881 304.738L260.789 302.427L261.633 303.027L255.734 305.336ZM275.285 296.761L274.325 297.137L275.176 297.727L276.127 297.352L275.285 296.761ZM276.128 297.352L278.003 298.667L278.519 296.421L276.128 297.352ZM272.254 294.633L275.285 296.761L278.76 295.404L279.614 291.73L272.254 294.633ZM270.039 307.883L269.079 308.259L269.922 308.85L270.882 308.474L270.039 307.883ZM271.399 302.666L268.235 300.441L262.593 302.65L261.633 303.026L264.797 305.251L265.641 305.851L266.609 305.474L265.756 304.875L271.399 302.666ZM272.252 303.264L266.61 305.473L270.039 307.883L275.681 305.673L272.252 303.264ZM277.792 299.568L275.176 297.727L269.195 300.064L272.359 302.289L271.408 302.664L272.252 303.264L273.212 302.888L272.368 302.288L277.639 300.228L277.792 299.568ZM270.039 307.883L275.681 305.674L272.252 303.265L266.61 305.474L270.039 307.883ZM271.399 302.666L268.235 300.441L262.593 302.65L261.633 303.026L264.797 305.251L265.641 305.851L266.609 305.474L265.756 304.875L271.399 302.666ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM265.641 305.851L259.741 308.152L263.171 310.57L269.079 308.259L265.641 305.851ZM263.063 311.537L256.782 313.988L260.789 316.726L266.986 314.302L263.063 311.537ZM263.171 310.57L262.211 310.946L263.063 311.536L264.014 311.161L263.171 310.57ZM269.922 308.851L264.015 311.162L267.947 313.927L273.846 311.617L269.922 308.851ZM270.881 308.474L274.813 311.238L275.103 311.125L276.203 306.399L270.881 308.474ZM270.039 307.883L269.079 308.259L269.922 308.85L270.882 308.474L270.039 307.883ZM261.633 303.027L255.734 305.337L258.898 307.562L264.797 305.252L261.633 303.027ZM261.633 303.027L255.734 305.337L258.898 307.562L264.797 305.252L261.633 303.027ZM261.633 303.027L255.734 305.337L258.898 307.562L264.797 305.252L261.633 303.027Z"
            fill="#0F0C0B"
         />
         <path
            d="M270.418 332.327L283.887 273.454C284.396 271.228 285.945 269.383 288.05 268.496L360.406 237.994C361.915 237.358 363.484 238.762 363.019 240.332L345.668 298.929L270.418 332.327Z"
            fill="#F1ECDC"
            stroke="#0F0C0B"
            strokeMiterlimit="10"
         />
         <path
            d="M324.77 278.066C326.838 279.26 327.279 282.37 325.754 285.011C324.229 287.652 321.317 288.825 319.248 287.631C317.18 286.437 316.738 283.327 318.263 280.686C319.788 278.045 322.701 276.872 324.77 278.066Z"
            fill="#0F0C0B"
         />
      </svg>
   )
}
